/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_None_TextInputs */

const en_audio_description_export_preset_none_text = /** @type {(inputs: Audio_Description_Export_Preset_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No audio description export presets have been saved yet. Create a preset by clicking "Save Preset".`)
};

const fr_audio_description_export_preset_none_text = /** @type {(inputs: Audio_Description_Export_Preset_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun préréglage d'exportation de description audio n'a été enregistré. Créez un préréglage en cliquant sur "Enregistrer le préréglage".`)
};

const de_audio_description_export_preset_none_text = /** @type {(inputs: Audio_Description_Export_Preset_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden noch keine Exportvoreinstellungen für Audiobeschreibungen gespeichert. Erstellen Sie eine Voreinstellung, indem Sie auf „Voreinstellung speichern“ klicken.`)
};

const it_audio_description_export_preset_none_text = /** @type {(inputs: Audio_Description_Export_Preset_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non sono ancora stati salvati preset di esportazione per le audiodescrizioni. Crea un preset cliccando su "Salva preset".`)
};

const ru_audio_description_export_preset_none_text = /** @type {(inputs: Audio_Description_Export_Preset_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока не сохранено ни одного предустановленного параметра экспорта аудиоописания. Создайте параметр, нажав кнопку «Сохранить параметр».`)
};

const es_audio_description_export_preset_none_text = /** @type {(inputs: Audio_Description_Export_Preset_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se han guardado ajustes preestablecidos para la exportación de audiodescripción. Cree un ajuste preestablecido haciendo clic en "Guardar ajuste preestablecido".`)
};

const zh_cn2_audio_description_export_preset_none_text = /** @type {(inputs: Audio_Description_Export_Preset_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未保存任何音频描述导出预设。点击“保存预设”创建预设。`)
};

const ja_audio_description_export_preset_none_text = /** @type {(inputs: Audio_Description_Export_Preset_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声解説のエクスポートプリセットはまだ保存されていません。「プリセットを保存」をクリックしてプリセットを作成してください。`)
};

const hi_audio_description_export_preset_none_text = /** @type {(inputs: Audio_Description_Export_Preset_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई ऑडियो विवरण निर्यात प्रीसेट सहेजा नहीं गया है। "प्रीसेट सहेजें" पर क्लिक करके एक प्रीसेट बनाएं।`)
};

const pt_pt2_audio_description_export_preset_none_text = /** @type {(inputs: Audio_Description_Export_Preset_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma predefinição de exportação de audiodescrição foi salva ainda. Crie uma predefinição clicando em "Salvar predefinição".`)
};

/**
* | output |
* | --- |
* | "No audio description export presets have been saved yet. Create a preset by clicking \"Save Preset\"." |
*
* @param {Audio_Description_Export_Preset_None_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_none_text = /** @type {((inputs?: Audio_Description_Export_Preset_None_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_None_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_none_text(inputs)
	if (locale === "de") return de_audio_description_export_preset_none_text(inputs)
	if (locale === "it") return it_audio_description_export_preset_none_text(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_none_text(inputs)
	if (locale === "es") return es_audio_description_export_preset_none_text(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_none_text(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_none_text(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_none_text(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_none_text(inputs)
	return en_audio_description_export_preset_none_text(inputs)
});